import { UserProfileApi, UserSettingsApi } from './endpoints';
import { AbstractApi, AbstractApiParams } from '../abstract-api';

export class UserApi extends AbstractApi {
  constructor(params: AbstractApiParams) {
    super(params);
  }

  public profile = new UserProfileApi(this.params);
  public settings = new UserSettingsApi(this.params);
}
